import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Suppress cross-origin "Script error." (e.g. Spreadshirt widget) from React dev overlay
// Must run before React mounts so our capture handler fires first
window.addEventListener("error", (e) => {
  if (e.message === "Script error." || e.message === "") {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, { capture: true });

// Service Worker for Web Push Notifications
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
